export const setItems = (items) => {
    return {
        type: 'TRAILER_SET_ITEMS',
        payload: {
            items,
        },
    };
};
export const setSearchValue = (value) => {
    return {
        type: 'TRAILER_SET_SEARCH_VALUE',
        payload: {
            value,
        },
    };
};
export const setSelectedItem = (data) => {
    return {
        type: 'TRAILER_SET_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};
export const setSortSelectedItem = (data) => {
    return {
        type: 'TRAILER_SET_SORT_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};
export const addItem = (data) => {
    return {
        type: 'TRAILER_ADD_ITEM',
        payload: {
            data,
        },
    };
};
export const updateItem = (data) => {
    return {
        type: 'TRAILER_UPDATE_ITEM',
        payload: {
            data,
        },
    };
};
export const deleteItem = (id) => {
    return {
        type: 'TRAILER_DELETE_ITEM',
        payload: {
            id,
        },
    };
};
